// extracted by mini-css-extract-plugin
export var deleteModal = "_sq-0";